<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper screenFlashNotification" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="screenFlashNotificationWindow clickable fadeIn" @click="onModalClose(close)" ng-class="{fadeIn: fadeIn, fadeOut: fadeOut}">
				<div class="backgroundFlare rotate">
					<div class="flareRay" v-for="n in (1, 12)"></div>
				</div>
				<div ng-if="::windowParams.notificationType" class="screenNotificationContent heroLevelUp" src="::'tpl/screenFlashNotification/types/'+windowParams.notificationType+'.html'">
					<div class="notificationBackground hero_levelUpNotification_huge_illu"></div>
					<i class="levelStar symbol_star_small_illu"></i>
					<span class="heroLevel length1">9</span>
					<span class="levelUpText"><span>Новый уровень героя</span></span>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>